export default "__VITE_ASSET__B3_IHJbw__"